export const calculateTotalRow = (data, totals) => {
    if (!data || data.length === 0) return null;

    const safeDiv = (a, b) => (b ? a / b : 0);

    const sums = {
        TotRooms: 0,
        TransRooms: 0,
        GrpRooms: 0,
        CurrRoomsSold: 0,
        CurrRoomRev: 0,
        PickUpRooms: 0,
        PickUpRoomRev: 0,
        BudRoomsSold: 0,
        BudRoomRev: 0,
        LYRoomsSold: 0,
        LYRoomRev: 0,
        RoomsSoldVar: 0,
        RoomRevVar: 0,
        LYRoomsSoldVar: 0,
        LYRoomRevVar: 0,
    };

    let totalPickUpADR = 0;
    let countPickUpADR = 0;

    data.forEach(row => {
        sums.TotRooms += parseFloat(row.TotRooms) || 0;
        sums.TransRooms += parseFloat(row.TransRooms) || 0;
        sums.GrpRooms += parseFloat(row.GrpRooms) || 0;
        sums.CurrRoomsSold += parseFloat(row.CurrRoomsSold) || 0;
        sums.CurrRoomRev += parseFloat(row.CurrRoomRev) || 0;
        const rowPickUpRooms = parseFloat(row.PickUpRooms) || 0;
        const rowPickUpRoomRev = parseFloat(row.PickUpRoomRev) || 0;
        const rowPickUpADR = parseFloat(row.PickUpADR);
        sums.PickUpRooms += rowPickUpRooms;
        sums.PickUpRoomRev += rowPickUpRoomRev;
        if (!Number.isNaN(rowPickUpADR)) {
            totalPickUpADR += rowPickUpADR;
            countPickUpADR++;
        }
        sums.BudRoomsSold += parseFloat(row.BudRoomsSold) || 0;
        sums.BudRoomRev += parseFloat(row.BudRoomRev) || 0;
        sums.LYRoomsSold += parseFloat(row.LYRoomsSold) || 0;
        sums.LYRoomRev += parseFloat(row.LYRoomRev) || 0;
        sums.RoomsSoldVar += parseFloat(row.RoomsSoldVar) || 0;
        sums.RoomRevVar += parseFloat(row.RoomRevVar) || 0;
        sums.LYRoomsSoldVar += parseFloat(row.LYRoomsSoldVar) || 0;
        sums.LYRoomRevVar += parseFloat(row.LYRoomRevVar) || 0;
    });

    // Use provided totals or fallback to first row of data if it contains total fields
    const sourceTotals = totals || (data && data.length > 0 ? data[0] : null);

    // Override sums with API totals if provided
    if (sourceTotals) {
        if (sourceTotals.TotalOTBRoomsSold !== undefined) sums.CurrRoomsSold = sourceTotals.TotalOTBRoomsSold;
        if (sourceTotals.TotalActualRoomsSold !== undefined) sums.CurrRoomsSold = sourceTotals.TotalActualRoomsSold;
        if (sourceTotals.TotalOTBRoomRevenue !== undefined) sums.CurrRoomRev = sourceTotals.TotalOTBRoomRevenue;
        if (sourceTotals.TotalActualRoomRevenue !== undefined) sums.CurrRoomRev = sourceTotals.TotalActualRoomRevenue;
        if (sourceTotals.TotalRoomsAvailable !== undefined) sums.TotRooms = sourceTotals.TotalRoomsAvailable;
        if (sourceTotals.TotalPickUpRooms !== undefined) sums.PickUpRooms = sourceTotals.TotalPickUpRooms;
        if (sourceTotals.TotalPickUpRoomRevenue !== undefined) sums.PickUpRoomRev = sourceTotals.TotalPickUpRoomRevenue;
        if (sourceTotals.TotalBudgetRoomsSold !== undefined) sums.BudRoomsSold = sourceTotals.TotalBudgetRoomsSold;
        if (sourceTotals.TotalBudgetRoomRevenue !== undefined) sums.BudRoomRev = sourceTotals.TotalBudgetRoomRevenue;
        if (sourceTotals.TotalLYRoomsSold !== undefined) sums.LYRoomsSold = sourceTotals.TotalLYRoomsSold;
        if (sourceTotals.TotalLYRoomRevenue !== undefined) sums.LYRoomRev = sourceTotals.TotalLYRoomRevenue;
    }

    // OTB Actuals
    // Occupancy = (Room sold total / total Room total) * 100
    const currOcc = safeDiv(sums.CurrRoomsSold, sums.TotRooms) * 100;
    // ADR = Total Room Revenue / Total Rooms Sold
    const currADR = safeDiv(sums.CurrRoomRev, sums.CurrRoomsSold);
    const currRevPar = safeDiv(sums.CurrRoomRev, sums.TotRooms);

    // Pickup
    const pickUpADR = countPickUpADR
        ? safeDiv(totalPickUpADR, countPickUpADR)
        : safeDiv(sums.PickUpRoomRev, sums.PickUpRooms);
    const pickUpOcc = safeDiv(sums.PickUpRooms, sums.TotRooms) * 100;

    // Budget
    // Use specific budget capacity if available (and non-zero), else fallback to TotRooms
    const budCapacity = (sourceTotals && sourceTotals.TotalBudRoomsAvailable) ? sourceTotals.TotalBudRoomsAvailable : sums.TotRooms;
    const budOcc = safeDiv(sums.BudRoomsSold, budCapacity) * 100;
    const budADR = safeDiv(sums.BudRoomRev, sums.BudRoomsSold);
    const budRevPar = safeDiv(sums.BudRoomRev, budCapacity);

    // LY Actuals
    // Use specific LY capacity if available (and non-zero), else fallback to TotRooms
    const lyCapacity = (sourceTotals && sourceTotals.TotalLYRoomsAvailable) ? sourceTotals.TotalLYRoomsAvailable : sums.TotRooms;
    const lyOcc = safeDiv(sums.LYRoomsSold, lyCapacity) * 100;
    const lyADR = safeDiv(sums.LYRoomRev, sums.LYRoomsSold);
    const lyRevPar = safeDiv(sums.LYRoomRev, lyCapacity);

    return {
        ...sums,
        CurrOcc: currOcc,
        CurrADR: currADR,
        CurrRevPar: currRevPar,

        PickUpADR: pickUpADR,
        PickUpOcc: pickUpOcc,

        BudOcc: budOcc,
        BudADR: budADR,
        BudRevPar: budRevPar,

        LYOcc: lyOcc,
        LYADR: lyADR,
        LYRevPar: lyRevPar,

        // Variances
        // Recalculate variances based on final sums (in case totals were overridden)
        RoomsSoldVar: sums.CurrRoomsSold - sums.BudRoomsSold,
        RoomRevVar: sums.CurrRoomRev - sums.BudRoomRev,
        OccVar: currOcc - budOcc,
        ADRVar: currADR - budADR,
        LYRoomsSoldVar: sums.CurrRoomsSold - sums.LYRoomsSold,
        LYRoomRevVar: sums.CurrRoomRev - sums.LYRoomRev,
        LYOccVar: currOcc - lyOcc,
        LYADRVar: currADR - lyADR,
    };
};
